var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 0.25C8.11621 0.25 4.75 3.61621 4.75 7.75C4.75 9.5459 5.37988 11.1924 6.4375 12.4844L0.460938 18.4609L1.53906 19.5391L7.51562 13.5625C8.80762 14.6201 10.4541 15.25 12.25 15.25C16.3838 15.25 19.75 11.8838 19.75 7.75C19.75 3.61621 16.3838 0.25 12.25 0.25ZM12.25 1.75C15.5723 1.75 18.25 4.42773 18.25 7.75C18.25 11.0723 15.5723 13.75 12.25 13.75C8.92773 13.75 6.25 11.0723 6.25 7.75C6.25 4.42773 8.92773 1.75 12.25 1.75Z",
    fill: "#3B7AF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.839ca22bb774415ca5e015453bcc2e93.svg";
export { ForwardRef as ReactComponent };